// @flow

import React from 'react'
import Container from './Container'
import Appear from './Appear'

type File = {
  file: string
}

type FooterNetwork = {
  key: string,
  title: string,
  file: File,
  url: string,
}

type FooterLogo = {
  key: string,
  file: File,
  ctaURL: string,
}

type Props = {
  networks: Array<FooterNetwork>,
  organizers: Array<FooterLogo>,
  support: Array<FooterLogo>,
  colaborators: Array<FooterLogo>,
  patrocinators: Array<FooterLogo>,
  secretaria_tecnica: string,
  secretaria_tecnica_text: string,
  organitza: string,
  suport_de: string,
  collaboracio_de: string,
  patrocina: string,
}

const Spacer = () => (
  <div className="-mx-5 md:mx-0">
    <Container>
      <div className="py-px bg-white" />
    </Container>
  </div>
)

const LinkImage = ({ key, url, title, file, networks }) => {
  const content = (
    <div className="flex flex-col items-center justify-center mt-10 mb-12 font-bold grayScale md:mr-3 lg:mr-12 md:mb-0 md:mt-0 md:flex-row md:justify-start text-blue">
      <img
        className={`${networks ? 'w-10' : 'w-4/5 md:w-64'} block h-auto mb-1 cursor-pointer md:mb-0 md:mr-2`}
        src={file.file}
        alt={title}
        style={{ minWidth: "24px" }}
      />
      <span>{title}</span>
    </div>
  )
  if (typeof url !== 'undefined' && url.length > 0) {
    return (
      <a
        key={key}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="md:mr-12"
      >
        {content}
      </a>
    )
  }
  return content
}

const Items = ({ items, networks }) => (
  <div key="items" className="flex flex-col items-center justify-center mt-12 md:mt-6 md:items-center md:justify-start md:flex-row">
    {items.map(item => <LinkImage networks={networks} key={item.file.file} {...item} />)}
  </div>
)

const Footer = ({
  networks,
  organizers,
  support,
  colaborators,
  patrocinators,
  secretaria_tecnica,
  secretaria_tecnica_text,
  organitza,
  suport_de,
  collaboracio_de,
  patrocina,
}: Props) => {
  return (
    <footer className="overflow-hidden bg-gray md:py-4 md:overflow-x-auto">
      <Appear>
        <Container key="networks" className="flex flex-col items-center justify-center py-12 md:py-8 md:justify-start md:flex-row">
          <div key="text" className="flex flex-col items-center justify-center md:items-start md:justify-start md:mr-8">
            <strong>{secretaria_tecnica}</strong>
            <a href="mailto:secretaria@grupcongres.com">secretaria@grupcongres.com</a>
            <span>{secretaria_tecnica_text}</span>
          </div>
          <Items networks={true} items={networks} />
        </Container>
        <Spacer />
      </Appear>
      <Appear>
        <Container key="support-colaborators" className="flex flex-col pt-12 pb-4 md:flex-row md:items-stretch md:justify-between md:py-8">
          <div>
            <div key="text" className="flex items-center justify-center md:block">
              <strong>{organitza}</strong>
            </div>
            <Items networks={false} items={organizers} />
          </div>
          {patrocinators.length > 0 && (
            <div className="mb-12 -mx-5 md:hidden">
              <Spacer />
            </div>
          )}
          {patrocinators.length > 0 && (
            <div className="flex flex-col items-stretch justify-between">
              <div key="text" className="flex items-center justify-center md:block">
                <strong>{patrocina}</strong>
              </div>
              <Items networks={false} items={patrocinators} />
            </div>
          )}
        </Container>
        <Spacer />
      </Appear>
      <Appear>
        <Container key="support-colaborators" className="flex flex-col pt-12 pb-4 md:flex-row md:items-stretch md:justify-between md:py-8">
          <div>
            <div key="text" className="flex items-center justify-center md:block">
              <strong>{suport_de}</strong>
            </div>
            <Items networks={false} items={support} />
          </div>
          <div className="mb-12 -mx-5 md:hidden">
            <Spacer />
          </div>
          <div>
            <div key="text" className="flex items-center justify-center md:block">
              <strong>{collaboracio_de}</strong>
            </div>
            <Items networks={false} items={colaborators} />
          </div>
        </Container>
      </Appear>
    </footer>
  )
}

export default Footer
